module.exports = __webpack_public_path__ + "static/RR0-83f3d13cbe66220d1cbf40b138762063.jpg";